import classnames from "classnames";
import React from "react";
import Slider, { Settings } from "react-slick";
import { LazyloadImage } from "src/components";
import { ISlider } from "src/types/prismic";
import styled from "styled-components";

import { Hyperlink } from "..";

const Wrapper = styled.section`
  &&& {
    color: black;
    font-size: 12px;
    overflow-x: auto;
    text-align: left;
    padding: 30px 15px;

    .slick-list {
      margin: 0 50px;
    }

    .slick-dots {
      margin: 0;
      bottom: 0;

      &:after {
        content: initial;
      }

      li,
      button {
        padding: 0;
      }

      button {
        display: flex;
        align-items: center;
        justify-items: center;

        &:before {
          content: initial;
        }
      }
    }

    .slick-arrow {
      display: inline-block;
      width: initial;
      height: initial;
      z-index: 1;

      &:hover:before {
        background: rgba(255, 255, 255, 0.4);
      }

      &:before {
        content: "〉";
        font-family: cursive;
        font-size: 35px;
        color: #000;
        position: relative;
        display: block;
      }

      &.slick-next {
        right: 0;
      }
      &.slick-prev {
        left: 0;

        &:before {
          transform: scaleX(-1);
        }
      }
    }
  }
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

const StyledHyperLink = styled(Hyperlink)``;

interface IProps {
  data: ISlider;
  className?: string;
}

const BannerSlider = ({ data, className }: IProps): JSX.Element => {
  const {
    classnames: sliderClassnames,
    has_dots: dots,
    has_arrows: arrows,
    infinite,
    slide_to_show: slidesToShow,
    slide_to_show_tablet: slidesToShowTablet,
    slide_to_show_mobile: slidesToShowMobile,
    slide_to_scroll: slidesToScroll,
    slide_to_scroll_tablet: slidesToScrollTablet,
    slide_to_scroll_mobile: slidesToScrollMobile,
    pause_on_hover: pauseOnHover,
    lazyLoad,
    fade_transition: fade,
    autoplay,
    autoplay_speed: autoplaySpeed,
    speed,
  } = data.primary;

  const responsive = [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: slidesToShowTablet || 2,
        slidesToScroll: slidesToScrollTablet || 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: slidesToShowMobile || 1,
        slidesToScroll: slidesToScrollMobile || 1,
      },
    },
  ];

  const settings: Settings = {
    dots,
    arrows,
    infinite,
    pauseOnHover,
    fade,
    autoplay,
    lazyLoad,
    responsive,
    // Don't write number props equal to null
    ...(slidesToShow ? { slidesToShow } : {}),
    ...(slidesToScroll ? { slidesToScroll } : {}),
    ...(autoplaySpeed ? { autoplaySpeed } : {}),
    ...(speed ? { speed } : {}),
  };

  return (
    <Wrapper className={classnames("slider", sliderClassnames, className)}>
      <Slider {...settings}>
        {data.items.map(({ url, src }, i) => (
          <StyledHyperLink to={url} key={i}>
            <LazyloadImage height={src?.dimensions?.height}>
              <Image src={src?.url} alt={src?.alt} />
            </LazyloadImage>
          </StyledHyperLink>
        ))}
      </Slider>
    </Wrapper>
  );
};

export default BannerSlider;
